import request from '@/utils/request'

import JSEncrypt from 'jsencrypt'

const publicKey = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC9pl8IMzS983m1xgWsPKtgIr2v
6BUykb3S1NFfpiL0UaL+9RujrtrdytUxSbetUfMRKgD3MyO5l5i79NYr+TSR0AR9
jeY+/kz/2cP7+v5luH1cd29Ylz+vP7eB3lZDFFgP54t2KhnSbTI5yX2Iw5z++PBb
DZ26HTpVGt4EUkBg1wIDAQAB
-----END PUBLIC KEY-----
`
var sign = new JSEncrypt()
sign.setPublicKey(publicKey)

export function loginApi(username, password, studio_id){
  password = sign.encrypt(password)
  return request({
    url: "/api/v1/auth/login",
    method: 'post',
    data: {
      username,
      password,
      studio_id
    }
  })
}

// export function loginApi(username, password, studio_id){
//   return request({
//     url: "/api/v1/auth/login",
//     method: 'post',

//     data: {
//       username,
//       password,
//       studio_id
//     }
//   })
// }

export function logoutApi() {
  return request({
    url: '/api/v1/auth/logout',
    method: 'post'
  })
}

export function getUserInfoApi(params) {
  if(!params) {
    params = {}
  }
  return request({
    url: '/api/v1/user/info',
    method: 'get',
    params
  })
}

//用户管理
export function getUserListApi(studioName, username, status, page, num) {
  let params = {}
  if(studioName !== undefined) {
    params['studio_name'] = studioName
  }
  if(username !== undefined) {
    params['username'] = username
  }
  if(status !== undefined) {
    params['status'] = status
  }
  if(page !== undefined) {
    params['page'] = page
  }
  if(num !== undefined) {
    params['num'] = num
  }
  return request({
    url: '/api/v1/user/list',
    method: 'get',
    params: params
  })
}
export function updateUserInfoApi(userInfo) {
  return request({
    url: '/api/v1/user/',
    method: 'put',
    data: userInfo
  })
}
export function getStudioListApi(name, masterUser, status){
  let params = {}
  if(name !== undefined) {
    params['name'] = name
  }
  if(masterUser !== undefined) {
    params['master_user'] = masterUser
  }
  if(status !== undefined) {
    params['status'] = status
  }
  return request({
    url: '/api/v1/studio/list',
    method: 'get',
    params: params
  })
}
export function getGroupListApi(name, page, num){
  let params = {}
  if (name !== undefined) {
    params['name'] = name
  }
  if(page !== undefined) {
    params['page'] = page
  }
  if(num !== num) {
    params['num'] = num
  }
  return request({
    url: '/api/v1/group/list',
    method: 'get',
    params: params
  })
}

//查询工作室老师
export function getTeachersListApi(name, page, num){
  let params = {}
  if (name !== undefined) {
    params['name'] = name
  }
  if(page !== undefined) {
    params['page'] = page
  }
  if(num !== num) {
    params['num'] = num
  }
  return request({
    url: '/api/v1/user/teachers',
    method: 'get',
    params: params
  })
}
export function deleteUserApi(data){
    return request({
      url: '/api/v1/user/',
      method: 'delete',
      data
    })
}
export function createUserApi(data) {
  return request({
    url: '/api/v1/auth/signup',
    method: 'post',
    data: data
  })
}
export function postSetPasswordApi(data) {
  return request({
    url: '/api/v1/user/set_password/',
    method: 'post',
    data: data
  })
}
export function getUserExistApi(username) {
  let params = {}
  if(username !== undefined) {
    params['username'] = username
  }
  return request({
    url: '/api/v1/user/check/',
    method: 'get',
    params: params
  })
}

export function getUserStudiosApi(username) {
  return request({
    url: '/api/v1/user/studio/',
    method: 'get',
    params: {username}
  })
}

export function validateUserApi(username) {
  return request({
    url: '/api/v1/user/validate_user/',
    method: 'get',
    params: {username}
  })
}

export function checkUserPasswordApi(password) {
  return request({
    url: '/api/v1/user/check_password/',
    method: 'get',
    params: {password}
  })
}
